import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { ANDREA_UPDATE_MODAL } from '../../config/updateModalContent';

export interface UpdateAnnounceModalProps {
  open: boolean;
  onClose: () => void;
}

const UpdateAnnounceModal: React.FC<UpdateAnnounceModalProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  const { headerTitle, footerLinkLabel, image, sections } = ANDREA_UPDATE_MODAL;

  const handleSettingsClick = () => {
    onClose();
    navigate('/settings');
  };

  return ReactDOM.createPortal(
    <>
      <div className="sidebar__modal-overlay" onClick={onClose} />
      <div className="sidebar__update-modal" role="dialog" aria-labelledby="update-modal-title">
        <button
          type="button"
          className="sidebar__profile-close"
          onClick={onClose}
          aria-label="Close update announcement"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="sidebar__update-modal-header">
          <h2 id="update-modal-title" className="sidebar__update-modal-title">
            {headerTitle}
          </h2>
        </div>

        <div className="sidebar__update-modal-body">
          <div className="sidebar__update-modal-content">
            <img
              src={image.src}
              alt={image.alt}
              className="sidebar__update-modal-img"
            />
            {sections.map((section) => (
              <div key={section.title} className="sidebar__update-modal-section">
                <h3 className="sidebar__update-modal-section-title">{section.title}</h3>
                <ReactMarkdown>{section.content}</ReactMarkdown>
              </div>
            ))}
          </div>
        </div>

        <div className="sidebar__update-modal-footer">
          <button
            type="button"
            className="sidebar__update-modal-settings-link"
            onClick={handleSettingsClick}
          >
            {footerLinkLabel}
          </button>
        </div>
      </div>
    </>,
    document.body,
  );
};

export default UpdateAnnounceModal;
